import React, { Component } from 'react';

import SiteCreate from './SiteCreate.js';
import SiteEdit from './SiteEdit.js';

class SiteManagement extends Component {
  constructor(props) {
    super(props);
    this.state = {
      view: '',
    }
  }

  render() {
    switch (this.state.view) {
      case "SiteCreate":
        return <SiteCreate cancel={() => this.setState({view: ""})} />
      case "SiteEdit":
        return <SiteEdit cancel={() => this.setState({view: ""})} />
      default:
        return (
          <div>
            <h2 className="form-title">Site Management</h2>
            <div className="row">
              <div className="col-md-6">
                <button className="btn btn-primary" type="button" onClick={() => this.setState({view: "SiteCreate"})}>
                  <span className="glyphicon glyphicon-duplicate"></span> Create Site
                </button>
              </div>
              <div className="col-md-6">
                <button className="btn btn-primary" type="button" onClick={() => this.setState({view: "SiteEdit"})}>
                  <span className="glyphicon glyphicon-pencil"></span> Edit Site
                </button>
              </div>
            </div>
          </div>
        )
    }
  }
}

export default SiteManagement;


// WEBPACK FOOTER //
// ./src/Components/SiteManagement/SiteManagement.js